import { render, staticRenderFns } from "./RoleIntegrationByRfc.vue?vue&type=template&id=f4a08b72&"
import script from "./RoleIntegrationByRfc.vue?vue&type=script&lang=js&"
export * from "./RoleIntegrationByRfc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports